// 首先导入并执行兼容性补丁
import './utils/polyfill'

export * from './auth'
export * from './crypto'
export * from './string'
export * from './convert'
export * from './network'
export * from './ui'
export * from './media'
export * from './file'
export * from './validator'
export * from './utils'
export * from './version'
export * from './styles'
export * from './threejs'
export * from './shuchk'

// 导入 HookFun 类
import { HookFun } from './auth/hookFun'

// 将 HookFun 挂载到全局对象，确保 UMD 模式下可以访问
if (typeof window !== 'undefined') {
  (window as any).HookFun = HookFun
}

// 默认导出
export { HookFun }
export default { HookFun }
